import axiosApi from '../../../../Shared/api/axiosApi'

class CustomContentApi {
    static getPayload(customPageId) {
        let requestUrl = 'ServiceRouter/CustomContentService/CustomContent/' + customPageId;

        return axiosApi.get(requestUrl, true).then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default CustomContentApi;  